import { Box, Grid, Typography } from "@mui/material";
import logo from "../../assets/images/Logo.png";
import styles from "./HomeNew.module.css";
import { useNavigate } from "react-router-dom";
import Footer from "./HomeFooter";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { PiBuildings } from "react-icons/pi";
import { GoLightBulb } from "react-icons/go";
import profile_image6 from "../../assets/images/profile-picture 6.jpg";
import profile_image7 from "../../assets/images/profile-picture 7.jpg";
import profile_image8 from "../../assets/images/profile-picture 8.jpg";
import profile_image9 from "../../assets/images/profile-picture 9.jpg";
import profile_image10 from "../../assets/images/profile-picture 10.jpg";
import { IoIosArrowRoundBack } from "react-icons/io";
import { IoIosArrowRoundForward } from "react-icons/io";
import review_image from "../../assets/images/One Image.jpg";
import write from "../../assets/images/Write.gif";
import { RxHamburgerMenu } from "react-icons/rx";
import { useState } from "react";
import { IoStar } from "react-icons/io5";
import { IoStarOutline } from "react-icons/io5";
import { IoStarHalfOutline } from "react-icons/io5";
import Fade from "react-reveal/Fade";
import { FaUser } from "react-icons/fa6";

const FeedbackMore = ({ title, progress, color }) => {
  const naviagte = useNavigate();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const gender = [
    {
      value: "Male",
      label: "Male",
    },
    {
      value: "Female",
      label: "Female",
    },
    {
      value: "Other",
      label: "Other",
    },
  ];

  return (
    <Box>
     <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>

        <span className={styles.nav_links}>
          <a onClick={() => navigate("//")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Home
            </b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "20px" }} />
            <b
              style={{
                marginLeft: "5px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Our Platform
            </b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              About Us
            </b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Contact Us
            </b>
          </a>
          <Box className={styles.login_btn} sx={{ marginLeft: '10px'}}>
              <a onClick={() => navigate("/login")}>
                Login <FaUser style={{color:'#fff' , fontSize:'14px',marginLeft: "5px",}}/>
              </a>
            </Box>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("//")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px  ",
                  fontWeight: "500",
                }}
              >
                Home
              </b>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </b>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                About Us
              </b>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Contact Us
              </b>
            </a>
            <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                Login <FaUser style={{color:'#fff' , fontSize:'14px',marginLeft: "5px",}}/>
              </a>
            </Box>
          </Box>
        )}
      </Box>
      <Box sx={{ padding: "35px" }} id="home" />

      <Box className={styles.home_structure}>
        <Fade bottom delay={200}>
          <Box className={styles.heading_contain}>
            <b>Last 03 months feedback from Users</b>
          </Box>
          <Box className={styles.feedback_more_section} id="platform">
            {/* <Box sx={{ width: "30%" }}>

                    </Box> */}
            <Grid container sx={{ width: "98%" }}>
              <Grid
                item
                xs={12}
                sm={6}
                md={5}
                lg={5}
                className={styles.feedback_details}
                sx={{
                  position: 'relative',
                  bottom: {
                    xs: '0px', 
                    sm: '0px', 
                    md: '40px', 
                    lg: '40px', 
                    xl: '40px', 
                  },
                }}
              >
                <Box sx={{ width: "110%" }}>
                  <Box className={styles.servies_more_requirement}>
                    <img
                      src={write}
                      alt=""
                      width="90px"
                      height="90px"
                      style={{ marginLeft: "10px" }}
                    />
                    <span style={{ marginTop: "20px" }}>
                      <button
                        style={{ marginBottom: "30px" }}
                        className={styles.centerButton}
                        onClick={() => navigate("/login")}
                      >
                        Write Review
                      </button>
                      <Box sx={{ marginBottom: "20px" }}>
                        <IoStar
                          style={{ fontSize: "23px", color: "#fccc51" }}
                        />
                        <IoStar
                          style={{ fontSize: "23px", color: "#fccc51" }}
                        />
                        <IoStar
                          style={{ fontSize: "23px", color: "#fccc51" }}
                        />
                        <IoStar
                          style={{ fontSize: "23px", color: "#fccc51" }}
                        />
                        <IoStar
                          style={{ fontSize: "23px", color: "#fccc51" }}
                        />
                      </Box>
                      <Typography>
                        <b>
                          <Typography sx={{ fontSize: "17px !important" }}>
                            {" "}
                            <b>Always our user top priority for us. </b>
                          </Typography>
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          marginBottom: "50px",
                          fontSize: "16px !important",
                        }}
                      >
                        Dear user please share your feedback to improve our
                        service quality.
                      </Typography>
                    </span>
                    <span style={{ marginBottom: "50px" }}>
                      <img
                        src={review_image}
                        alt=""
                        style={{
                          width: "100%",
                          height: "auto",
                          maxWidth: "375px",
                          maxHeight: "100px",
                        }}
                      />
                    </span>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={7} lg={7} sx={{ padding: "20px " }}>
                <div>
                  <span className={styles.second}>
                    <Box>
                      <img
                        src={profile_image6}
                        alt=""
                        width="55px"
                        height="55px"
                        style={{
                          borderRadius: "50%",
                          marginRight: "20px",
                          border: "3.5px solid #d9d9d9",
                        }}
                      />

                      <span style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            <b>Divya Rawat– Bench Sales Recruiter </b>
                          </Typography>
                          <Box>
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                             <IoStar
                              style={{ fontSize: "20px", color: "#b8b7b7" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#b8b7b7" }}
                            />
                          </Box>
                        </Box>
                        <a>
                          <Typography
                            sx={{
                              color: "gray",
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                                Date: 20 –July 2024  
                          </Typography>
                        </a>
                      </span>
                    </Box>
                    <span>
                      <Typography
                        sx={{
                          paddingTop: "5px",
                          fontSize: {
                            xs: "14px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        Povial is a great ATS that helps you to track the
                        candidate and requirements on daily recruitment life,
                        really It has been a great experience using to Povital
                        ATS from other job portal and I met a great UI/UX and
                        integrations. The system is very fast and smooth with
                        great ideal dashboards for reporting.
                        <br />
                      </Typography>
                    </span>
                  </span>
                  <br />
                  <span className={styles.second}>
                    <Box>
                      <img
                        src={profile_image7}
                        alt=""
                        width="55px"
                        height="55px"
                        style={{
                          borderRadius: "50%",
                          marginRight: "20px",
                          border: "3.5px solid #d9d9d9",
                        }}
                      />
                      <span style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            <b>Sahil Khan– Sr. IT Recruiter</b>
                          </Typography>
                          <Box>
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                          </Box>
                        </Box>
                        <a>
                          <Typography
                            sx={{
                              color: "gray",
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                        Date: 19 –July 2024{" "}    
                          </Typography>
                        </a>
                      </span>
                    </Box>
                    <span>
                      <Typography
                        sx={{
                          paddingTop: "5px",
                          fontSize: {
                            xs: "14px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        My feedback is here after using this, it's good to use
                        and easy to integrate with vendors and resources which
                        track workforce management without any extra efforts,
                        the overall experience was fabulous because it's very
                        easy to use. I also recommend all staffing professions.
                        <br />
                      </Typography>
                    </span>
                  </span>
                  <br />
                  <span className={styles.second}>
                    <Box>
                      <img
                        src={profile_image8}
                        alt=""
                        width="55px"
                        height="55px"
                        style={{
                          borderRadius: "50%",
                          marginRight: "20px",
                          border: "3.5px solid #d9d9d9",
                        }}
                      />

                      <span style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            <b>Martik Velikori– Sr. Bench Sales Recruiter</b>
                          </Typography>
                          <Box>
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#b8b7b7" }}
                            />
                          </Box>
                        </Box>
                        <a>
                          <Typography
                            sx={{
                              color: "gray",
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                             Date: 19 –July 2024
                          </Typography>
                        </a>
                      </span>
                    </Box>
                    <span>
                      <Typography
                        sx={{
                          paddingTop: "5px",
                          fontSize: {
                            xs: "14px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        The povital application works well. It could be much
                        more intuitive but it is highly functional. there are
                        some challenges in customer service response time, I
                        suggest to povital they must more work on application
                        and support team.
                        <br />
                      </Typography>
                    </span>
                  </span>
                  <br />
                  <span className={styles.second}>
                    <Box>
                      <img
                        src={profile_image9}
                        alt=""
                        width="55px"
                        height="55px"
                        style={{
                          borderRadius: "50%",
                          marginRight: "20px",
                          border: "3.5px solid #d9d9d9",
                        }}
                      />
                      <span style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            <b>Davis M– Sr. Bench Sales Recruiter</b>
                          </Typography>
                          <Box>
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#b8b7b7" }}
                            />
                             <IoStar
                              style={{ fontSize: "20px", color: "#b8b7b7" }}
                            />
                          </Box>
                        </Box>
                        <a>
                          <Typography
                            sx={{
                              color: "gray",
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                      Date: 17 –July 2024{" "} 
                          </Typography>
                        </a>
                      </span>
                    </Box>
                    <span>
                      <Typography
                        sx={{
                          paddingTop: "5px",
                          fontSize: {
                            xs: "14px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        Here is my overall experience with povital job board and
                        ATS is very fantastic, it is very simple and user
                        friendly to use I sure even no training required for a
                        fresher staffing professional, you can fetch the data by
                        putting simple quarries and results as accurate you
                        want.
                        <br />
                      </Typography>
                    </span>
                  </span>
                  <br />
                  <span className={styles.second}>
                    <Box>
                      <img
                        src={profile_image10}
                        alt=""
                        width="55px"
                        height="55px"
                        style={{
                          borderRadius: "50%",
                          marginRight: "20px",
                          border: "3.5px solid #d9d9d9",
                        }}
                      />

                      <span style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            <b>Akash Tiwari – IT Recruiter </b>
                          </Typography>
                          <Box>
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                          </Box>
                        </Box>
                        <a>
                          <Typography
                            sx={{
                              color: "gray",
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                         Date: 10 –June 2024 
                          </Typography>
                        </a>
                      </span>
                    </Box>
                    <span>
                      <Typography
                        sx={{
                          paddingTop: "5px",
                          fontSize: {
                            xs: "14px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        My experience with Povital Job Board and ATS has been
                        excellent. It's incredibly user-friendly, requiring no
                        training even for beginners. The search function is
                        simple yet delivers precise and accurate results.
                        <br />
                      </Typography>
                    </span>
                  </span>
                </div>
              </Grid>
            </Grid>
          </Box>
          <Box className={styles.next_btns}>
            <Box className={styles.add_back_btns}>
              <button
                onClick={() => navigate(-1)}
                style={{
                  border: "1.5px solid #4285f4",
                  marginRight: "10px",
                  padding: "4.5px 10px ",
                }}
              >
                <IoIosArrowRoundBack
                  style={{ fontSize: "25px", color: "#4285f4" }}
                />
              </button>
            </Box>
          </Box>
        </Fade>
        <Box>
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

export default FeedbackMore;
